import { default as icons_45page3Ac4Tu7j1WMeta } from "/app/node_modules/@nuxtjs/svg-sprite/dist/runtime/components/icons-page.vue?macro=true";
import { default as _404STh7p7T7N0Meta } from "/app/pages/404.vue?macro=true";
import { default as addon14hKGnYFwdMeta } from "/app/pages/administration/addon.vue?macro=true";
import { default as analyticsQmVdLHeLRxMeta } from "/app/pages/administration/analytics.vue?macro=true";
import { default as average_45checkmo1ff0ctdzMeta } from "/app/pages/administration/average-check.vue?macro=true";
import { default as categoriesUCrIrRPi40Meta } from "/app/pages/administration/categories.vue?macro=true";
import { default as _91id_93wJxDQUftu5Meta } from "/app/pages/administration/combos/[id].vue?macro=true";
import { default as indexZJMQU3nM0kMeta } from "/app/pages/administration/combos/index.vue?macro=true";
import { default as combosYiHL4EqbEYMeta } from "/app/pages/administration/combos.vue?macro=true";
import { default as dish_45groupsCqSh2ggPZ5Meta } from "/app/pages/administration/dish-groups.vue?macro=true";
import { default as excludeIngredientsZzPpjZ7TWtMeta } from "/app/pages/administration/excludeIngredients.vue?macro=true";
import { default as funnelsvOhB8sGgyIMeta } from "/app/pages/administration/funnels.vue?macro=true";
import { default as homeoawaVYqWw9Meta } from "/app/pages/administration/home.vue?macro=true";
import { default as indexqkct2RzjmAMeta } from "/app/pages/administration/index.vue?macro=true";
import { default as institutionsm3ojb3wIMGMeta } from "/app/pages/administration/institutions.vue?macro=true";
import { default as _91slug_93gcCIK8JdH2Meta } from "/app/pages/administration/knowledge-base/[slug].vue?macro=true";
import { default as indexKcut4To6rVMeta } from "/app/pages/administration/knowledge-base/index.vue?macro=true";
import { default as abuse7F6LxVdCRZMeta } from "/app/pages/administration/loyalty/abuse.vue?macro=true";
import { default as account_45linksipz4KzuyLzMeta } from "/app/pages/administration/loyalty/account-links.vue?macro=true";
import { default as cleanupJEKAM4RNI1Meta } from "/app/pages/administration/loyalty/cleanup.vue?macro=true";
import { default as notificationsEoYaReI8XeMeta } from "/app/pages/administration/loyalty/notifications.vue?macro=true";
import { default as pointsx9CpyE210NMeta } from "/app/pages/administration/loyalty/points.vue?macro=true";
import { default as settingsdcTmEpQLr4Meta } from "/app/pages/administration/loyalty/settings.vue?macro=true";
import { default as mobile_45analytics61r3JCHG8mMeta } from "/app/pages/administration/mobile-analytics.vue?macro=true";
import { default as indexR9TsUooOU8Meta } from "/app/pages/administration/news-slider/index.vue?macro=true";
import { default as _91id_93keILApIMNkMeta } from "/app/pages/administration/notifications/[id].vue?macro=true";
import { default as index28PQQQVJeXMeta } from "/app/pages/administration/notifications/index.vue?macro=true";
import { default as settingsohSnkpsUkFMeta } from "/app/pages/administration/notifications/settings.vue?macro=true";
import { default as stats5tSPz61SlNMeta } from "/app/pages/administration/notifications/stats.vue?macro=true";
import { default as _91id_93RzS4Nn9SKBMeta } from "/app/pages/administration/orders/[id].vue?macro=true";
import { default as indexrc2CNt935zMeta } from "/app/pages/administration/orders/index.vue?macro=true";
import { default as _91id_93x5epr2yCDHMeta } from "/app/pages/administration/productGroup/[id].vue?macro=true";
import { default as indexHyBMKjwG6cMeta } from "/app/pages/administration/productGroup/index.vue?macro=true";
import { default as productGroupVmVieSfKFeMeta } from "/app/pages/administration/productGroup.vue?macro=true";
import { default as _91id_93ypM1kvAAsKMeta } from "/app/pages/administration/products/[id].vue?macro=true";
import { default as indexrQtVJITiIjMeta } from "/app/pages/administration/products/index.vue?macro=true";
import { default as newZdyY7v3gIjMeta } from "/app/pages/administration/products/new.vue?macro=true";
import { default as productsTKMlSnHZ0lMeta } from "/app/pages/administration/products.vue?macro=true";
import { default as indexhgSe2INZgxMeta } from "/app/pages/administration/promocodes/index.vue?macro=true";
import { default as referral6p3SQbyQiuMeta } from "/app/pages/administration/referral.vue?macro=true";
import { default as analyticsdKkT5iu5QzMeta } from "/app/pages/administration/retention/analytics.vue?macro=true";
import { default as _91id_9386dn52akTsMeta } from "/app/pages/administration/retention/campaigns/[id].vue?macro=true";
import { default as createwFVsDOC7koMeta } from "/app/pages/administration/retention/campaigns/create.vue?macro=true";
import { default as indexYckNa1IFrEMeta } from "/app/pages/administration/retention/campaigns/index.vue?macro=true";
import { default as indexcLrOi5nSEYMeta } from "/app/pages/administration/retention/index.vue?macro=true";
import { default as _91id_93cInIqkl7QRMeta } from "/app/pages/administration/retention/notification-templates/[id].vue?macro=true";
import { default as createMvWqt9vsDYMeta } from "/app/pages/administration/retention/notification-templates/create.vue?macro=true";
import { default as index7iwO6ReLYZMeta } from "/app/pages/administration/retention/notification-templates/index.vue?macro=true";
import { default as settingsfwsPilEwnXMeta } from "/app/pages/administration/retention/settings.vue?macro=true";
import { default as _91id_93GglyjKTiMVMeta } from "/app/pages/administration/reviews/[id].vue?macro=true";
import { default as indexJVPhAJy9iIMeta } from "/app/pages/administration/reviews/index.vue?macro=true";
import { default as settingsWcFW88V9n0Meta } from "/app/pages/administration/settings.vue?macro=true";
import { default as staffI1TypbZwgdMeta } from "/app/pages/administration/staff.vue?macro=true";
import { default as indexcdKoAEw3krMeta } from "/app/pages/administration/support/index.vue?macro=true";
import { default as stickersGmUWWVhg6nMeta } from "/app/pages/administration/support/stickers.vue?macro=true";
import { default as tagsCm4EC01YUVMeta } from "/app/pages/administration/tags.vue?macro=true";
import { default as index56xUPm18dFMeta } from "/app/pages/administration/ui/index.ts?macro=true";
import { default as indexK50URIvRNnMeta } from "/app/pages/administration/users/index.vue?macro=true";
import { default as weekly_45giftcLpsmmliukMeta } from "/app/pages/administration/weekly-gift.vue?macro=true";
import { default as workload_45controlKaMdmM7XccMeta } from "/app/pages/administration/workload-control.vue?macro=true";
import { default as yandex_45deliveryUttwBG7d2DMeta } from "/app/pages/administration/yandex-delivery.vue?macro=true";
import { default as app_45downloadssIXoGzGzAMeta } from "/app/pages/app-download.vue?macro=true";
import { default as indexrDfwYAJTNxMeta } from "/app/pages/app-redirect/index.ts?macro=true";
import { default as loginJfs9k54iJjMeta } from "/app/pages/app-redirect/login.vue?macro=true";
import { default as reset_45password4njMP9znXdMeta } from "/app/pages/app-redirect/reset-password.vue?macro=true";
import { default as indexlqEJsKn8lSMeta } from "/app/pages/app-redirect/ui/index.ts?macro=true";
import { default as verifyEmailw8EXq6B9SrMeta } from "/app/pages/app-redirect/verifyEmail.vue?macro=true";
import { default as debug_45pushz1dbc6YiopMeta } from "/app/pages/debug-push.vue?macro=true";
import { default as indexE2sGBwgrueMeta } from "/app/pages/debug/index.ts?macro=true";
import { default as order_45switcherLiipXZ38CVMeta } from "/app/pages/debug/order-switcher.vue?macro=true";
import { default as indexGv1Qfa3AxsMeta } from "/app/pages/debug/ui/index.ts?macro=true";
import { default as _91slug_9306UXtCMDmAMeta } from "/app/pages/dish/[slug].vue?macro=true";
import { default as indexqMxChm5hmGMeta } from "/app/pages/dish/index.ts?macro=true";
import { default as DishScreen2mVq2OjLHTMeta } from "/app/pages/dish/ui/DishScreen.vue?macro=true";
import { default as failg1VwBkHh72Meta } from "/app/pages/fail.vue?macro=true";
import { default as favoritesYMtsvzhBvNMeta } from "/app/pages/favorites.vue?macro=true";
import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as activation_45historyIBl00BG8ENMeta } from "/app/pages/lk/activation-history.vue?macro=true";
import { default as addressesvY3tYdeXprMeta } from "/app/pages/lk/addresses.vue?macro=true";
import { default as indexz9azWFSbfJMeta } from "/app/pages/lk/index.vue?macro=true";
import { default as loyalty_45history2SCsEn9xWXMeta } from "/app/pages/lk/loyalty-history.vue?macro=true";
import { default as notificationsW2Dvq5bBQEMeta } from "/app/pages/lk/notifications.vue?macro=true";
import { default as personal_45informationd8uTT447JYMeta } from "/app/pages/lk/personal-information.vue?macro=true";
import { default as PersonalLoyaltyAkCiQ8Rn8LMeta } from "/app/pages/lk/PersonalLoyalty.vue?macro=true";
import { default as referralwM0WCljr2OMeta } from "/app/pages/lk/referral.vue?macro=true";
import { default as replenishment_45storieshcAnLwUZQgMeta } from "/app/pages/lk/replenishment-stories.vue?macro=true";
import { default as safety8H0EvjkMigMeta } from "/app/pages/lk/safety.vue?macro=true";
import { default as indexeHdLD1cmWJMeta } from "/app/pages/lk/ui/index.ts?macro=true";
import { default as logInYandexKcSqYgJCxmMeta } from "/app/pages/logInYandex.vue?macro=true";
import { default as _91slug_93pzYueGgvMSMeta } from "/app/pages/menu/[slug].vue?macro=true";
import { default as indexBvnBJ0IXcLMeta } from "/app/pages/menu/index.ts?macro=true";
import { default as MenuCategoryScreenPqb7m4f3DiMeta } from "/app/pages/menu/ui/MenuCategoryScreen.vue?macro=true";
import { default as indexhfiK1jgmVyMeta } from "/app/pages/mocks/index.ts?macro=true";
import { default as order_45statusklE1po89DmMeta } from "/app/pages/mocks/order-status.vue?macro=true";
import { default as indexPMP1NCcncrMeta } from "/app/pages/mocks/ui/index.ts?macro=true";
import { default as notifications883AI3QFtaMeta } from "/app/pages/notifications.vue?macro=true";
import { default as orderBjfxujOe1OMeta } from "/app/pages/order.vue?macro=true";
import { default as _91slug_93NVspau3cAjMeta } from "/app/pages/p/[slug].vue?macro=true";
import { default as indexNK5riOUsrLMeta } from "/app/pages/p/index.ts?macro=true";
import { default as ContentPageScreenxX2QSRiJmhMeta } from "/app/pages/p/ui/ContentPageScreen.vue?macro=true";
import { default as policyhDmBrXN4qOMeta } from "/app/pages/policy.vue?macro=true";
import { default as privacyg3gwBRGXatMeta } from "/app/pages/privacy.vue?macro=true";
import { default as _91name_93ycvL1azk2hMeta } from "/app/pages/profile/[name].vue?macro=true";
import { default as indexY1fdekcBWBMeta } from "/app/pages/profile/index.ts?macro=true";
import { default as indexil6q7IcDK1Meta } from "/app/pages/profile/ui/index.ts?macro=true";
import { default as reset_45password52TOS9kgCUMeta } from "/app/pages/reset-password.vue?macro=true";
import { default as success0bZk2aWKHZMeta } from "/app/pages/success.vue?macro=true";
import { default as supportPKo8CaxFTuMeta } from "/app/pages/support.vue?macro=true";
import { default as ui_45kitxRnkS5jbEfMeta } from "/app/pages/ui-kit.vue?macro=true";
import { default as verifyEmailFOExcU54QgMeta } from "/app/pages/verifyEmail.vue?macro=true";
export default [
  {
    name: "icons-page",
    path: "/_icons",
    meta: {"layout":"svg-sprite"},
    component: () => import("/app/node_modules/@nuxtjs/svg-sprite/dist/runtime/components/icons-page.vue")
  },
  {
    name: "404",
    path: "/404",
    meta: _404STh7p7T7N0Meta || {},
    component: () => import("/app/pages/404.vue")
  },
  {
    name: "administration-addon",
    path: "/administration/addon",
    meta: addon14hKGnYFwdMeta || {},
    component: () => import("/app/pages/administration/addon.vue")
  },
  {
    name: "administration-analytics",
    path: "/administration/analytics",
    meta: analyticsQmVdLHeLRxMeta || {},
    component: () => import("/app/pages/administration/analytics.vue")
  },
  {
    name: "administration-average-check",
    path: "/administration/average-check",
    meta: average_45checkmo1ff0ctdzMeta || {},
    component: () => import("/app/pages/administration/average-check.vue")
  },
  {
    name: "administration-categories",
    path: "/administration/categories",
    meta: categoriesUCrIrRPi40Meta || {},
    component: () => import("/app/pages/administration/categories.vue")
  },
  {
    name: combosYiHL4EqbEYMeta?.name,
    path: "/administration/combos",
    meta: combosYiHL4EqbEYMeta || {},
    component: () => import("/app/pages/administration/combos.vue"),
    children: [
  {
    name: "administration-combos-id",
    path: ":id()",
    meta: _91id_93wJxDQUftu5Meta || {},
    component: () => import("/app/pages/administration/combos/[id].vue")
  },
  {
    name: "administration-combos",
    path: "",
    meta: indexZJMQU3nM0kMeta || {},
    component: () => import("/app/pages/administration/combos/index.vue")
  }
]
  },
  {
    name: "administration-dish-groups",
    path: "/administration/dish-groups",
    meta: dish_45groupsCqSh2ggPZ5Meta || {},
    component: () => import("/app/pages/administration/dish-groups.vue")
  },
  {
    name: "administration-excludeIngredients",
    path: "/administration/excludeIngredients",
    meta: excludeIngredientsZzPpjZ7TWtMeta || {},
    component: () => import("/app/pages/administration/excludeIngredients.vue")
  },
  {
    name: "administration-funnels",
    path: "/administration/funnels",
    meta: funnelsvOhB8sGgyIMeta || {},
    component: () => import("/app/pages/administration/funnels.vue")
  },
  {
    name: "administration-home",
    path: "/administration/home",
    meta: homeoawaVYqWw9Meta || {},
    component: () => import("/app/pages/administration/home.vue")
  },
  {
    name: "administration",
    path: "/administration",
    meta: indexqkct2RzjmAMeta || {},
    component: () => import("/app/pages/administration/index.vue")
  },
  {
    name: "administration-institutions",
    path: "/administration/institutions",
    meta: institutionsm3ojb3wIMGMeta || {},
    component: () => import("/app/pages/administration/institutions.vue")
  },
  {
    name: "administration-knowledge-base-slug",
    path: "/administration/knowledge-base/:slug()",
    meta: _91slug_93gcCIK8JdH2Meta || {},
    component: () => import("/app/pages/administration/knowledge-base/[slug].vue")
  },
  {
    name: "administration-knowledge-base",
    path: "/administration/knowledge-base",
    meta: indexKcut4To6rVMeta || {},
    component: () => import("/app/pages/administration/knowledge-base/index.vue")
  },
  {
    name: "administration-loyalty-abuse",
    path: "/administration/loyalty/abuse",
    meta: abuse7F6LxVdCRZMeta || {},
    component: () => import("/app/pages/administration/loyalty/abuse.vue")
  },
  {
    name: "administration-loyalty-account-links",
    path: "/administration/loyalty/account-links",
    meta: account_45linksipz4KzuyLzMeta || {},
    component: () => import("/app/pages/administration/loyalty/account-links.vue")
  },
  {
    name: "administration-loyalty-cleanup",
    path: "/administration/loyalty/cleanup",
    meta: cleanupJEKAM4RNI1Meta || {},
    component: () => import("/app/pages/administration/loyalty/cleanup.vue")
  },
  {
    name: "administration-loyalty-notifications",
    path: "/administration/loyalty/notifications",
    meta: notificationsEoYaReI8XeMeta || {},
    component: () => import("/app/pages/administration/loyalty/notifications.vue")
  },
  {
    name: "administration-loyalty-points",
    path: "/administration/loyalty/points",
    meta: pointsx9CpyE210NMeta || {},
    component: () => import("/app/pages/administration/loyalty/points.vue")
  },
  {
    name: "administration-loyalty-settings",
    path: "/administration/loyalty/settings",
    meta: settingsdcTmEpQLr4Meta || {},
    component: () => import("/app/pages/administration/loyalty/settings.vue")
  },
  {
    name: "administration-mobile-analytics",
    path: "/administration/mobile-analytics",
    meta: mobile_45analytics61r3JCHG8mMeta || {},
    component: () => import("/app/pages/administration/mobile-analytics.vue")
  },
  {
    name: "administration-news-slider",
    path: "/administration/news-slider",
    meta: indexR9TsUooOU8Meta || {},
    component: () => import("/app/pages/administration/news-slider/index.vue")
  },
  {
    name: "administration-notifications-id",
    path: "/administration/notifications/:id()",
    meta: _91id_93keILApIMNkMeta || {},
    component: () => import("/app/pages/administration/notifications/[id].vue")
  },
  {
    name: "administration-notifications",
    path: "/administration/notifications",
    meta: index28PQQQVJeXMeta || {},
    component: () => import("/app/pages/administration/notifications/index.vue")
  },
  {
    name: "administration-notifications-settings",
    path: "/administration/notifications/settings",
    meta: settingsohSnkpsUkFMeta || {},
    component: () => import("/app/pages/administration/notifications/settings.vue")
  },
  {
    name: "administration-notifications-stats",
    path: "/administration/notifications/stats",
    meta: stats5tSPz61SlNMeta || {},
    component: () => import("/app/pages/administration/notifications/stats.vue")
  },
  {
    name: "administration-orders-id",
    path: "/administration/orders/:id()",
    meta: _91id_93RzS4Nn9SKBMeta || {},
    component: () => import("/app/pages/administration/orders/[id].vue")
  },
  {
    name: "administration-orders",
    path: "/administration/orders",
    meta: indexrc2CNt935zMeta || {},
    component: () => import("/app/pages/administration/orders/index.vue")
  },
  {
    name: productGroupVmVieSfKFeMeta?.name,
    path: "/administration/productGroup",
    meta: productGroupVmVieSfKFeMeta || {},
    component: () => import("/app/pages/administration/productGroup.vue"),
    children: [
  {
    name: "administration-productGroup-id",
    path: ":id()",
    meta: _91id_93x5epr2yCDHMeta || {},
    component: () => import("/app/pages/administration/productGroup/[id].vue")
  },
  {
    name: "administration-productGroup",
    path: "",
    meta: indexHyBMKjwG6cMeta || {},
    component: () => import("/app/pages/administration/productGroup/index.vue")
  }
]
  },
  {
    name: productsTKMlSnHZ0lMeta?.name,
    path: "/administration/products",
    meta: productsTKMlSnHZ0lMeta || {},
    component: () => import("/app/pages/administration/products.vue"),
    children: [
  {
    name: "administration-products-id",
    path: ":id()",
    meta: _91id_93ypM1kvAAsKMeta || {},
    component: () => import("/app/pages/administration/products/[id].vue")
  },
  {
    name: "administration-products",
    path: "",
    meta: indexrQtVJITiIjMeta || {},
    component: () => import("/app/pages/administration/products/index.vue")
  },
  {
    name: "administration-products-new",
    path: "new",
    meta: newZdyY7v3gIjMeta || {},
    component: () => import("/app/pages/administration/products/new.vue")
  }
]
  },
  {
    name: "administration-promocodes",
    path: "/administration/promocodes",
    meta: indexhgSe2INZgxMeta || {},
    component: () => import("/app/pages/administration/promocodes/index.vue")
  },
  {
    name: "administration-referral",
    path: "/administration/referral",
    meta: referral6p3SQbyQiuMeta || {},
    component: () => import("/app/pages/administration/referral.vue")
  },
  {
    name: "administration-retention-analytics",
    path: "/administration/retention/analytics",
    meta: analyticsdKkT5iu5QzMeta || {},
    component: () => import("/app/pages/administration/retention/analytics.vue")
  },
  {
    name: "administration-retention-campaigns-id",
    path: "/administration/retention/campaigns/:id()",
    meta: _91id_9386dn52akTsMeta || {},
    component: () => import("/app/pages/administration/retention/campaigns/[id].vue")
  },
  {
    name: "administration-retention-campaigns-create",
    path: "/administration/retention/campaigns/create",
    meta: createwFVsDOC7koMeta || {},
    component: () => import("/app/pages/administration/retention/campaigns/create.vue")
  },
  {
    name: "administration-retention-campaigns",
    path: "/administration/retention/campaigns",
    meta: indexYckNa1IFrEMeta || {},
    component: () => import("/app/pages/administration/retention/campaigns/index.vue")
  },
  {
    name: "administration-retention",
    path: "/administration/retention",
    meta: indexcLrOi5nSEYMeta || {},
    component: () => import("/app/pages/administration/retention/index.vue")
  },
  {
    name: "administration-retention-notification-templates-id",
    path: "/administration/retention/notification-templates/:id()",
    meta: _91id_93cInIqkl7QRMeta || {},
    component: () => import("/app/pages/administration/retention/notification-templates/[id].vue")
  },
  {
    name: "administration-retention-notification-templates-create",
    path: "/administration/retention/notification-templates/create",
    meta: createMvWqt9vsDYMeta || {},
    component: () => import("/app/pages/administration/retention/notification-templates/create.vue")
  },
  {
    name: "administration-retention-notification-templates",
    path: "/administration/retention/notification-templates",
    meta: index7iwO6ReLYZMeta || {},
    component: () => import("/app/pages/administration/retention/notification-templates/index.vue")
  },
  {
    name: "administration-retention-settings",
    path: "/administration/retention/settings",
    meta: settingsfwsPilEwnXMeta || {},
    component: () => import("/app/pages/administration/retention/settings.vue")
  },
  {
    name: "administration-reviews-id",
    path: "/administration/reviews/:id()",
    meta: _91id_93GglyjKTiMVMeta || {},
    component: () => import("/app/pages/administration/reviews/[id].vue")
  },
  {
    name: "administration-reviews",
    path: "/administration/reviews",
    meta: indexJVPhAJy9iIMeta || {},
    component: () => import("/app/pages/administration/reviews/index.vue")
  },
  {
    name: "administration-settings",
    path: "/administration/settings",
    meta: settingsWcFW88V9n0Meta || {},
    component: () => import("/app/pages/administration/settings.vue")
  },
  {
    name: "administration-staff",
    path: "/administration/staff",
    meta: staffI1TypbZwgdMeta || {},
    component: () => import("/app/pages/administration/staff.vue")
  },
  {
    name: "administration-support",
    path: "/administration/support",
    meta: indexcdKoAEw3krMeta || {},
    component: () => import("/app/pages/administration/support/index.vue")
  },
  {
    name: "administration-support-stickers",
    path: "/administration/support/stickers",
    meta: stickersGmUWWVhg6nMeta || {},
    component: () => import("/app/pages/administration/support/stickers.vue")
  },
  {
    name: "administration-tags",
    path: "/administration/tags",
    meta: tagsCm4EC01YUVMeta || {},
    component: () => import("/app/pages/administration/tags.vue")
  },
  {
    name: "administration-ui",
    path: "/administration/ui",
    component: () => import("/app/pages/administration/ui/index.ts")
  },
  {
    name: "administration-users",
    path: "/administration/users",
    meta: indexK50URIvRNnMeta || {},
    component: () => import("/app/pages/administration/users/index.vue")
  },
  {
    name: "administration-weekly-gift",
    path: "/administration/weekly-gift",
    meta: weekly_45giftcLpsmmliukMeta || {},
    component: () => import("/app/pages/administration/weekly-gift.vue")
  },
  {
    name: "administration-workload-control",
    path: "/administration/workload-control",
    meta: workload_45controlKaMdmM7XccMeta || {},
    component: () => import("/app/pages/administration/workload-control.vue")
  },
  {
    name: "administration-yandex-delivery",
    path: "/administration/yandex-delivery",
    meta: yandex_45deliveryUttwBG7d2DMeta || {},
    component: () => import("/app/pages/administration/yandex-delivery.vue")
  },
  {
    name: "app-download",
    path: "/app-download",
    component: () => import("/app/pages/app-download.vue")
  },
  {
    name: "app-redirect",
    path: "/app-redirect",
    component: () => import("/app/pages/app-redirect/index.ts")
  },
  {
    name: "app-redirect-login",
    path: "/app-redirect/login",
    component: () => import("/app/pages/app-redirect/login.vue")
  },
  {
    name: "app-redirect-reset-password",
    path: "/app-redirect/reset-password",
    component: () => import("/app/pages/app-redirect/reset-password.vue")
  },
  {
    name: "app-redirect-ui",
    path: "/app-redirect/ui",
    component: () => import("/app/pages/app-redirect/ui/index.ts")
  },
  {
    name: "app-redirect-verifyEmail",
    path: "/app-redirect/verifyEmail",
    component: () => import("/app/pages/app-redirect/verifyEmail.vue")
  },
  {
    name: "debug-push",
    path: "/debug-push",
    meta: debug_45pushz1dbc6YiopMeta || {},
    component: () => import("/app/pages/debug-push.vue")
  },
  {
    name: "debug",
    path: "/debug",
    component: () => import("/app/pages/debug/index.ts")
  },
  {
    name: "debug-order-switcher",
    path: "/debug/order-switcher",
    component: () => import("/app/pages/debug/order-switcher.vue")
  },
  {
    name: "debug-ui",
    path: "/debug/ui",
    component: () => import("/app/pages/debug/ui/index.ts")
  },
  {
    name: "dish-slug",
    path: "/dish/:slug()",
    meta: _91slug_9306UXtCMDmAMeta || {},
    component: () => import("/app/pages/dish/[slug].vue")
  },
  {
    name: "dish",
    path: "/dish",
    component: () => import("/app/pages/dish/index.ts")
  },
  {
    name: "dish-ui-DishScreen",
    path: "/dish/ui/DishScreen",
    component: () => import("/app/pages/dish/ui/DishScreen.vue")
  },
  {
    name: "fail",
    path: "/fail",
    meta: failg1VwBkHh72Meta || {},
    component: () => import("/app/pages/fail.vue")
  },
  {
    name: "favorites",
    path: "/favorites",
    meta: favoritesYMtsvzhBvNMeta || {},
    component: () => import("/app/pages/favorites.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "lk-activation-history",
    path: "/lk/activation-history",
    meta: activation_45historyIBl00BG8ENMeta || {},
    component: () => import("/app/pages/lk/activation-history.vue")
  },
  {
    name: "lk-addresses",
    path: "/lk/addresses",
    meta: addressesvY3tYdeXprMeta || {},
    component: () => import("/app/pages/lk/addresses.vue")
  },
  {
    name: "lk",
    path: "/lk",
    component: () => import("/app/pages/lk/index.vue")
  },
  {
    name: "lk-loyalty-history",
    path: "/lk/loyalty-history",
    meta: loyalty_45history2SCsEn9xWXMeta || {},
    component: () => import("/app/pages/lk/loyalty-history.vue")
  },
  {
    name: "lk-notifications",
    path: "/lk/notifications",
    meta: notificationsW2Dvq5bBQEMeta || {},
    component: () => import("/app/pages/lk/notifications.vue")
  },
  {
    name: "lk-personal-information",
    path: "/lk/personal-information",
    meta: personal_45informationd8uTT447JYMeta || {},
    component: () => import("/app/pages/lk/personal-information.vue")
  },
  {
    name: "lk-PersonalLoyalty",
    path: "/lk/PersonalLoyalty",
    component: () => import("/app/pages/lk/PersonalLoyalty.vue")
  },
  {
    name: "lk-referral",
    path: "/lk/referral",
    meta: referralwM0WCljr2OMeta || {},
    component: () => import("/app/pages/lk/referral.vue")
  },
  {
    name: "lk-replenishment-stories",
    path: "/lk/replenishment-stories",
    component: () => import("/app/pages/lk/replenishment-stories.vue")
  },
  {
    name: "lk-safety",
    path: "/lk/safety",
    meta: safety8H0EvjkMigMeta || {},
    component: () => import("/app/pages/lk/safety.vue")
  },
  {
    name: "lk-ui",
    path: "/lk/ui",
    component: () => import("/app/pages/lk/ui/index.ts")
  },
  {
    name: "logInYandex",
    path: "/logInYandex",
    meta: logInYandexKcSqYgJCxmMeta || {},
    component: () => import("/app/pages/logInYandex.vue")
  },
  {
    name: "menu-slug",
    path: "/menu/:slug()",
    component: () => import("/app/pages/menu/[slug].vue")
  },
  {
    name: "menu",
    path: "/menu",
    component: () => import("/app/pages/menu/index.ts")
  },
  {
    name: "menu-ui-MenuCategoryScreen",
    path: "/menu/ui/MenuCategoryScreen",
    component: () => import("/app/pages/menu/ui/MenuCategoryScreen.vue")
  },
  {
    name: "mocks",
    path: "/mocks",
    component: () => import("/app/pages/mocks/index.ts")
  },
  {
    name: "mocks-order-status",
    path: "/mocks/order-status",
    component: () => import("/app/pages/mocks/order-status.vue")
  },
  {
    name: "mocks-ui",
    path: "/mocks/ui",
    component: () => import("/app/pages/mocks/ui/index.ts")
  },
  {
    name: "notifications",
    path: "/notifications",
    component: () => import("/app/pages/notifications.vue")
  },
  {
    name: "order",
    path: "/order",
    component: () => import("/app/pages/order.vue")
  },
  {
    name: "p-slug",
    path: "/p/:slug()",
    component: () => import("/app/pages/p/[slug].vue")
  },
  {
    name: "p",
    path: "/p",
    component: () => import("/app/pages/p/index.ts")
  },
  {
    name: "p-ui-ContentPageScreen",
    path: "/p/ui/ContentPageScreen",
    component: () => import("/app/pages/p/ui/ContentPageScreen.vue")
  },
  {
    name: "policy",
    path: "/policy",
    component: () => import("/app/pages/policy.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/app/pages/privacy.vue")
  },
  {
    name: "profile-name",
    path: "/profile/:name()",
    component: () => import("/app/pages/profile/[name].vue")
  },
  {
    name: "profile",
    path: "/profile",
    component: () => import("/app/pages/profile/index.ts")
  },
  {
    name: "profile-ui",
    path: "/profile/ui",
    component: () => import("/app/pages/profile/ui/index.ts")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: reset_45password52TOS9kgCUMeta || {},
    component: () => import("/app/pages/reset-password.vue")
  },
  {
    name: "success",
    path: "/success",
    meta: success0bZk2aWKHZMeta || {},
    component: () => import("/app/pages/success.vue")
  },
  {
    name: "support",
    path: "/support",
    meta: supportPKo8CaxFTuMeta || {},
    component: () => import("/app/pages/support.vue")
  },
  {
    name: "ui-kit",
    path: "/ui-kit",
    meta: ui_45kitxRnkS5jbEfMeta || {},
    component: () => import("/app/pages/ui-kit.vue")
  },
  {
    name: "verifyEmail",
    path: "/verifyEmail",
    meta: verifyEmailFOExcU54QgMeta || {},
    component: () => import("/app/pages/verifyEmail.vue")
  }
]